import { Component, Input, OnInit } from '@angular/core';
import { AppService } from '../../app.service';

@Component({
  selector: 'app-signup-success',
  templateUrl: './signup-success.component.html',
  styleUrls: ['./signup-success.component.scss'],
})
export class SignupSuccessComponent implements OnInit {
  constructor(
    private app: AppService,
  ) { }

  @Input() email: string;

  @Input() title: string = 'Welcome to Proportunity!';

  @Input() message: string = 'To log in';

  @Input() showBookCall: boolean = false;

  ngOnInit(): void { }

  bookCall(event?: MouseEvent | TouchEvent): void {
    this.app.bookCall('proportunity', 'chat-with-us');
  }
}
